import React, { useEffect, useState } from "react";
import { orderGet } from "../../redux/apis/orderAPI";
import { creareOrderEmail } from "../../utils/email";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { isNull } from "../../utils/validation";

const OrderDetail = () => {
  const [pending, setPending] = useState(true);
  const [error, setError] = useState(null);
  const order = useSelector((state) => state.orderReducer.currentOrder);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const fetchOrder = async () => {
    try {
      setError(null);
      await dispatch(orderGet(order.id));
    } catch (err) {
      setError("Order not found");
      console.error(err);
    }
  };

  useEffect(() => {
    try {
      if (location.state.login) {
        fetchOrder();
      } else {
        navigate("/dashboard/login");
      }
    } catch (e) {
      navigate("/dashboard/login");
    }
  }, []);

  useEffect(() => {
    if (order?.cart) {
      setPending(false);
    }
  }, [order]);

  return (
    <div className="min-h-screen">
      {error ? (
        <div className="flex items-center justify-center min-h-screen">
          <div className="text-center">
            <h2 className="font-semibold text-red-600 mb-4">
              {error}
            </h2>
            <button
              onClick={() =>
                navigate("/dashboard", { state: { login: true } })
              }
              className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700"
            >
              Return to Dashboard
            </button>
          </div>
        </div>
      ) : isNull(order) || Object.keys(order).length === 0 ? (
        <div className="flex items-center justify-center min-h-screen">
          <div className="text-center">
            <h2 className="font-semibold text-gray-900 mb-4">
              Order not found
            </h2>
            <button
              onClick={() =>
                navigate("/dashboard", { state: { login: true } })
              }
              className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700"
            >
              Return to Dashboard
            </button>
          </div>
        </div>
      ) : !pending ? (
        <div>
          <div className="flex justify-between" style={{ margin: "40px" }}>
            <div className="flex gap-2">
              <div
                onClick={() =>
                  navigate("/dashboard", { state: { login: true } })
                }
                className="text-blue-600 underline cursor-pointer"
              >
                Dashboard
              </div>
              / Order - {order.payment.orderId}
            </div>
            {/* <div className="flex gap-4 justify-end">
              <Listbox value={selected} onChange={setSelected}>
                <div className="relative">
                  <Listbox.Button className="relative w-full cursor-default rounded-lg bg-white py-2 pl-3 pr-10 text-left shadow-md focus:outline-none focus-visible:border-indigo-500 focus-visible:ring-2 focus-visible:ring-white/75 focus-visible:ring-offset-2 focus-visible:ring-offset-orange-300 sm:text-sm">
                    <span className="block truncate">{selected.name}</span>
                    <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                      <ChevronUpDownIcon
                        className="h-5 w-5 text-gray-400"
                        aria-hidden="true"
                      />
                    </span>
                  </Listbox.Button>
                  <Transition
                    as={Fragment}
                    leave="transition ease-in duration-100"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                  >
                    <Listbox.Options className="absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm">
                      {statusList.map((st, indx) => (
                        <Listbox.Option
                          key={indx}
                          className={({ active }) =>
                            `relative cursor-default select-none py-2 pl-5 pr-4 ${
                              active
                                ? "bg-indigo-100 text-indigo-900"
                                : "text-gray-900"
                            }`
                          }
                          value={st}
                        >
                          {({ selected }) => (
                            <>
                              <span
                                className={`block truncate ${
                                  selected ? "font-medium" : "font-normal"
                                }`}
                              >
                                {st.name}
                              </span>
                              {selected ? (
                                <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-indigo-600">
                                  <CheckIcon
                                    className="h-5 w-5"
                                    aria-hidden="true"
                                  />
                                </span>
                              ) : null}
                            </>
                          )}
                        </Listbox.Option>
                      ))}
                    </Listbox.Options>
                  </Transition>
                </div>
              </Listbox>
            </div> */}
          </div>
          <div
            dangerouslySetInnerHTML={{
              __html: creareOrderEmail(order.payment, order.cart),
            }}
          ></div>
        </div>
      ) : (
        <>Loading...</>
      )}
    </div>
  );
};

export default OrderDetail;
